import React from "react";
import { Handle } from "reactflow";
import not_gate_gif from "../../assets/images/not_gate.gif";

const CustomGateNode = ({ data }) => {
  const { label, inputs = ["1", "2"] } = data;

  const calculatePosition = (index, total) => {
    return `${(index + 1) * (100 / (total + 1))}%`;
  };

  const isNotGate = label === "NOT";
  const activeInputs = isNotGate ? ["1"] : inputs.length > 0 ? inputs : ["1", "2"];

  return (
    <div className="relative w-20 h-12 bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border border-gray-600 rounded-lg shadow-xl flex items-center justify-center">
      {isNotGate ? (
        <img src={not_gate_gif} alt="NOT Gate" className="w-12 h-8" />
      ) : (
        <span className="text-white font-bold text-sm tracking-wider uppercase">{label}</span>
      )}

      {/* Render Input Handles matching input-1, input-2 */}
      {activeInputs.map((_, index) => (
        <Handle
          key={`input-${index + 1}`}
          type="target"
          id={`input-${index + 1}`}
          position="bottom"
          style={{
            left: calculatePosition(index, activeInputs.length),
            background: "#fff",
            borderRadius: "50%",
            width: "10px",
            height: "10px",
          }}
        />
      ))}

      {/* Render Output Handle matching output */}
      <Handle
        type="source"
        id="output"
        position="top"
        style={{
          background: "#fff",
          borderRadius: "50%",
          width: "10px",
          height: "10px",
        }}
      />
    </div>
  );
};

export default CustomGateNode;
